import { getFormattedDisplayNameForEqlField } from '@modules/common/components/EqlFieldsAutoComplete/helpers';
import { ShowFeedbackDrawerFromTableOptions } from '@modules/quantify/components/QuantifyReportTableWidget/types';
import { getSingleRecordQueryValueColumn } from '@modules/quantify/hooks/useGetQuantifyReportTableColumns/helpers/getAggregateFormulaValueColumn';
import { getMultiRecordQueryValueColumn } from '@modules/quantify/hooks/useGetQuantifyReportTableColumns/helpers/getMultiRecordQueryValueColumn';
import { QuantifyState } from '@modules/quantify/store/types';
import { EqlField, Formula } from 'generated/graphql';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface getFormulaValueColumnParams {
  formulaID?: EQLFunctionName;
  onFeedbackCountClick: (params: ShowFeedbackDrawerFromTableOptions) => void;
  columnHeaderName: string;
  groupBy: QuantifyState['query']['groupByField'];
  formulas: Formula[];
  isCompactTableVariant?: boolean;
  measuredAsCriteria: EqlField | undefined;
  isSingleRecordQuery: boolean;
  shouldRemoveFileUploadPrefix: boolean;
  isUnifiedFieldEnabled: boolean;
}

export function getFormulaValueColumn({
  formulaID,
  columnHeaderName,
  groupBy,
  onFeedbackCountClick,
  formulas,
  isCompactTableVariant,
  measuredAsCriteria,
  isSingleRecordQuery,
  shouldRemoveFileUploadPrefix,
  isUnifiedFieldEnabled,
}: getFormulaValueColumnParams) {
  if (isSingleRecordQuery) {
    const fieldName = getFormattedDisplayNameForEqlField({
      eqlField: groupBy,
      shouldRemoveFileUploadPrefix,
      isUnifiedFieldEnabled,
    });
    const formulaName = formulas
      ? formulas.find((formula) => formula.eqlFunction === formulaID)?.shortName
      : undefined;

    const headerName = formulaName
      ? `${fieldName} : ${formulaName}`
      : fieldName;

    return getSingleRecordQueryValueColumn({
      headerName,
      onFeedbackCountClick,
    });
  }

  return getMultiRecordQueryValueColumn({
    headerName: columnHeaderName,
    groupBy,
    onFeedbackCountClick,
    formulaID,
    isCompactTableVariant,
    measuredAsCriteria,
    shouldRemoveFileUploadPrefix,
    isUnifiedFieldEnabled,
  });
}
